
import Component from '../../../assets/scripts/modules/component'

export default class ArticleCookiesComponent extends Component {
  init () {
    this.observedIntersectionElements = this.element.querySelectorAll('.article-cookies__title, .article-cookies__text, .article-cookies__buttons')

    this.buttonChange = this.element.querySelector('.button--change')
    this.buttonClear = this.element.querySelector('.button--clear')
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.article-cookies').forEach(element => {
  element.instance = element.instance || new ArticleCookiesComponent(element)
}))
